export const REGISTRATION_FORM_BKP = 'REG_FORM';
export const REGISTRATION_FORM_VERSION = 'REG_FORM_VER';
